export default "__VITE_ASSET__6e4e907e__"